/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeContentRpc
 */
import * as References from './PersonalizeContentRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeContentRpc#createVariant
 */
export const CREATE_VARIANT_MUTATION_FIELD_NAME = 'com_hubspot_personalize_rpc_PersonalizeContentRpc_createVariant';
export const CREATE_VARIANT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_VARIANT_MUTATION_FIELD_NAME,
  args: ['assetCoordinates', 'variantName', 'segmentIdentifier', 'targetingConfig'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createVariantRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeContentRpc#deletePersonalization
 */
export const DELETE_PERSONALIZATION_MUTATION_FIELD_NAME = 'com_hubspot_personalize_rpc_PersonalizeContentRpc_deletePersonalization';
export const DELETE_PERSONALIZATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_PERSONALIZATION_MUTATION_FIELD_NAME,
  args: ['personalizationId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.deletePersonalizationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeContentRpc#deletePersonalizationStrategy
 */
export const DELETE_PERSONALIZATION_STRATEGY_MUTATION_FIELD_NAME = 'com_hubspot_personalize_rpc_PersonalizeContentRpc_deletePersonalizationStrategy';
export const DELETE_PERSONALIZATION_STRATEGY_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_PERSONALIZATION_STRATEGY_MUTATION_FIELD_NAME,
  args: ['personalizationStrategyId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.deletePersonalizationStrategyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.personalize.rpc.PersonalizeContentRpc#deletePersonalizedDefault
 */
export const DELETE_PERSONALIZED_DEFAULT_MUTATION_FIELD_NAME = 'com_hubspot_personalize_rpc_PersonalizeContentRpc_deletePersonalizedDefault';
export const DELETE_PERSONALIZED_DEFAULT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_PERSONALIZED_DEFAULT_MUTATION_FIELD_NAME,
  args: ['personalizationStrategyId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.deletePersonalizedDefaultRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});